export default __webpack_public_path__ + "static/media/not_expand.12a05e7c.svg";